import React from 'react';
import { useSelector } from 'react-redux';
import { getLang } from 'shared/store/selectors/lang.selector';
import { Tooltip } from 'src/components/core/tooltip/tooltip.component';
import styles from './acgme-badge.module.scss';

const AcgmeBadge = ({ size = 'medium', ...props }) => {
  const lang = useSelector(getLang('ROTATIONS'));
  const tooltipText = lang.ACGME_REQUIRED_TOOLTIP;

  return (
    <Tooltip title={tooltipText}>
      <span {...props} className={`${styles.badge} ${styles[size]}`} aria-label={tooltipText}>
        {lang.ACGME_BADGE_LABEL}
      </span>
    </Tooltip>
  );
};

export { AcgmeBadge };
